import React, { Fragment, useEffect, useState } from 'react';
import Banner from './Banner';
import Features from './Features';
import FreelancerBenefits from './FreelancerBenefits';
import FreelancerCTA from './FreelancerCTA';
import Footer from '../Footer/Footer';
import Loader from '../../loader/Loader';
import PageSEO from '../Common/PageSEO';
import { useLocale } from '../../localization/LocaleContext';


function FreelancersMain(){
    const { t, locale } = useLocale();

   const[loader, SetLoader] = useState(false)

    useEffect(() => {
        const timer = setTimeout(() => {
            SetLoader(true)
        }, 1500)

        return () => clearTimeout(timer)
    }, [])

    if (!loader) {
        return <Loader/>;
    }
    return(
        <Fragment>
            <PageSEO title={t('meta.freelancersTitle')} description={t('meta.freelancersDescription')} path="/freelancers" locale={locale} />
            <Banner />
            <Features />
            <FreelancerBenefits />
            <FreelancerCTA />
            <Footer />
        </Fragment>
    )
}

export default FreelancersMain;